// create new array for countries and appending a new object that represents default value
/* eslint-disable */
const countries = [
    {
        name: 'Select A Country',
        id: '',
        regionCode: '',
        code: ''
    },
    ...window.beaches_app.page.countries
];

const callingCodesObj = require('~/js/modules/countryCallingCodes');

// create new array for states and appending a new object that represents default value
const states = [...window.beaches_app.page.states];

import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import FileImageUpload from '~/js/components/form-controls/FileImageUpload';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="countryCode"
        stateName="state"
        stateLabelWrapper="lg-5"
        stateInputWrapper="lg-7"
        countryLabelWrapper="lg-5"
        countryInputWrapper="lg-7"
    />,
    document.getElementById('country-state-selector-1')
);

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="guestCountryCode"
        stateName="guestState"
        stateLabelWrapper="lg-5"
        stateInputWrapper="lg-7"
        countryLabelWrapper="lg-5"
        countryInputWrapper="lg-7"
    />,
    document.getElementById('country-state-selector-2')
);

ReactDOM.render(
    <CustomDatePicker
        name="checkInDate"
        // wrapperClassName="xs-12 lg-7"
        inputClassName="checkin-date-input"
        isRequired
        displayPlaceHolder
        displayStringDate={false}
    />,
    document.getElementById('checkin-datepicker')
);

ReactDOM.render(
    <FileImageUpload
        fileSizeLimit={3}
        isRequired
        name="document"
        btnMessage="CHOOSE FILE"
        displaySelectedFileName
    />,
    document.getElementById('upload-file')
);

ReactDOM.render(
    <CustomRecaptcha wrapperClassName="xs-12 lg-12" />,
    document.getElementById('google-recaptcha')
);

// form validations
import '~/js/modules/fend';

// form elements references
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');
const $guestLandLineNumber = $('#guestLandLineNumber');
const $guestMobileNumber = $('#guestMobileNumber');
const $countrySelector = $('select[name="countryCode"]');
const $subscribeLabel = $('.form-label[for="subscribe"]');
const $freeHoneymoonForm = $('#free-honeymoon-form');
const $validPhone = $('#contactNumberValid');
const $guestValidPhone = $('#guestContactNumberValid');

// Form Validation
$freeHoneymoonForm.fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        bookingNumber: 'alphanumeric',
        city: 'lettersOnly'
    },
    isMultiPart: true
});

$landlineNumber.change(function validateNumber() {
    if (this.value) {
        $validPhone.removeAttr('required');
        $mobileNumber.trigger('blur');
        $validPhone.val($landlineNumber.val());
        $validPhone.trigger('blur');
    } else {
        if ($mobileNumber.val()) {
            $validPhone.removeAttr('required');
            $validPhone.val($mobileNumber.val());
        } else {
            $validPhone.val('');
        }
        $validPhone.trigger('blur');
    }
});

$mobileNumber.change(function validateNumber() {
    if (this.value) {
        $validPhone.removeAttr('required');
        $landlineNumber.trigger('blur');
        $validPhone.val($mobileNumber.val());
        $validPhone.trigger('blur');
    } else {
        if ($landlineNumber.val()) {
            $validPhone.removeAttr('required');
            $validPhone.val($landlineNumber.val());
        } else {
            $validPhone.val('');
        }
        $validPhone.trigger('blur');
    }
});

$guestLandLineNumber.change(function validateNumber() {
    if (this.value) {
        $guestValidPhone.removeAttr('required');
        $guestMobileNumber.trigger('blur');
        $guestValidPhone.val($guestLandLineNumber.val());
        $guestValidPhone.trigger('blur');
    } else {
        if ($guestMobileNumber.val()) {
            $guestValidPhone.removeAttr('required');
            $guestValidPhone.val($guestMobileNumber.val());
        } else {
            $guestValidPhone.val('');
        }
        $guestValidPhone.trigger('blur');
    }
});

$guestMobileNumber.change(function validateNumber() {
    if (this.value) {
        $guestValidPhone.removeAttr('required');
        $guestLandLineNumber.trigger('blur');
        $guestValidPhone.val($guestMobileNumber.val());
        $guestValidPhone.trigger('blur');
    } else {
        if ($guestLandLineNumber.val()) {
            $guestValidPhone.removeAttr('required');
            $guestValidPhone.val($guestLandLineNumber.val());
        } else {
            $guestValidPhone.val('');
        }
        $guestValidPhone.trigger('blur');
    }
});

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', event => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));

    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
    }
});

$(document).ready(() => {
    if ($landlineNumber.val()) {
        $validPhone.removeAttr('required');
        $validPhone.val($landlineNumber.val());
        $mobileNumber.trigger('blur');
        $validPhone.trigger('blur');
    }

    if ($mobileNumber.val()) {
        $validPhone.removeAttr('required');
        $landlineNumber.trigger('blur');
        $validPhone.val($mobileNumber.val());
        $validPhone.trigger('blur');
    }

    if ($guestLandLineNumber.val()) {
        $guestValidPhone.removeAttr('required');
        $guestValidPhone.val($guestLandLineNumber.val());
        $guestMobileNumber.trigger('blur');
        $guestValidPhone.trigger('blur');
    }

    if ($guestMobileNumber.val()) {
        $guestValidPhone.removeAttr('required');
        $guestLandLineNumber.trigger('blur');
        $guestValidPhone.val($guestMobileNumber.val());
        $guestValidPhone.trigger('blur');
    }

    $('[name=countryCode]').on('change', function() {
        const selectedCountry = $(this).val();

        callingCodesObj.countryCodes.map(function(index) {
            if (selectedCountry === index.code) {
                $('span.countryCode').html(index.dial_code);
            }
        });
    });

    $('[name=guestCountryCode]').on('change', function() {
        const selectedCountry = $(this).val();

        callingCodesObj.countryCodes.map(function(index) {
            if (selectedCountry === index.code) {
                $('span.guestCountryCode').html(index.dial_code);
            }
        });
    });
});
